import { Flex, Spin } from "@payping/web-components";
import { Suspense } from "react";

const Loading = () => (
  <Suspense fallback="...">
    <Flex className="tw-h-full tw-min-w-full" justify="center" align="center">
      <Spin size="large" />
    </Flex>
  </Suspense>
);

export default Loading;
